import { MelwaysProvider } from '@seek/melways-react';
import type { Locale } from '@seek/melways-sites';
import { hydrateRoot } from 'react-dom/client';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import type { ConfigOptions } from 'src/app/shared/contexts/configProvider';
import { isProd } from 'src/app/utils/environment';
import { loadDatadog } from 'src/app/utils/logging';
import type { EmployerSiteName } from 'src/types/app';

import { createRoutes } from './router';
import { persistUivParams } from './shared/components/UivController/utils/persistUivParams';

interface Props {
  language: Locale;
  site: EmployerSiteName;
  config: ConfigOptions;
}

export default async (props: Props) => {
  persistUivParams();
  loadDatadog();

  const router = createBrowserRouter(createRoutes(props));

  hydrateRoot(
    document.getElementById('app')!,
    <MelwaysProvider.Client site={props.site} staging={!isProd()}>
      <RouterProvider router={router} />
    </MelwaysProvider.Client>,
  );
};
